/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Kind_Teal_Yak_SpotInputs */

const en_kind_teal_yak_spot = /** @type {(inputs: Kind_Teal_Yak_SpotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated memberships: ${i?.count}`)
};

const de_kind_teal_yak_spot = /** @type {(inputs: Kind_Teal_Yak_SpotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualisierte Benutzer: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Updated memberships: {count}" |
*
* @param {Kind_Teal_Yak_SpotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const kind_teal_yak_spot = /** @type {((inputs: Kind_Teal_Yak_SpotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Teal_Yak_SpotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kind_teal_yak_spot(inputs)
	return de_kind_teal_yak_spot(inputs)
});